import useGetNewsTips from './useGetNewsTips'

export default useGetNewsTips
